export const appsList = [
  {
    name: "Testsetu App",
  },
  {
    name: "Quiz App",
  },

  {
    name: "Wallpaper App",
  },
  {
    name: "Shayari App",
  },
];
